<template>
  <div class="pdf-container">
    <div class="pdf-box">
      <iframe
        class="pdf-frame"
        :src="pdfUrl"
        title="SanshuBio Introduction"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sanshubio',
  data() {
    return {
      pdfUrl: `${process.env.BASE_URL}files/三黍生物.pdf`,
    };
  },
};
</script>

<style scoped>
.pdf-container {
  width: 66%;
  margin: 0 auto;
  padding: 20px;
}

.pdf-box {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.pdf-frame {
  width: 100%;
  height: 900px;
  border: none;
}
</style>
